import React, { useCallback, useMemo } from 'react'
import classNames from 'classnames'
import CenterImageWrap from './center-image-wrap'
import formatDuration from 'lib/format-duration'
import { useResponsive } from 'Components/hooks/use-responsive'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface IProps {
  order?: number
  category: string
  className?: string
  uniqueIdStr: string
  title: string
  name: string
  userId: string
  imageList: any[]
  commentCount: number
  duration: number
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  order,
  category,
  uniqueIdStr,
  title,
  name,
  className,
  userId,
  imageList,
  commentCount,
  duration,
}) => {
  const responsive = useResponsive()

  const isVideo = useMemo(() => {
    return duration > 0
  }, [duration])

  const isSiglePic = useMemo(() => {
    // 1920/1680分辨率下，必须为3张
    if (responsive.xl) {
      return imageList?.length < 3 && imageList?.length > 0
    }
    return imageList?.length < 2 && imageList?.length > 0
  }, [imageList, responsive])

  const isNonePic = useMemo(() => {
    return imageList?.length < 1
  }, [imageList])

  const imageIndexClass = [
    'tw-inline-block tw-mr-8',
    'tw-hidden md:tw-inline-block xl:tw-inline-block xl:tw-mr-8',
    'tw-hidden xl:tw-inline-block',
  ]

  const renderImageList = () => {
    return (
      <>
        {imageList?.map((item: any, index) => {
          if (index < 1 || !isSiglePic) {
            return (
              <CenterImageWrap
                src={item?.url}
                width={222}
                height={124}
                lazy={true}
                wrapClassName={`feed-item-image ${imageIndexClass[index]}`}
                duration={duration ? formatDuration(duration) : ''}
              />
            )
          }
        })}
      </>
    )
  }

  return (
    <div
      className={`nav-feed-item ${className ? className : ''}`}
      key={`nav-feed-${uniqueIdStr}`}
    >
      <div
        className={classNames('top-content', {
          'sm:tw-block md:tw-flex md:tw-h-44': isSiglePic,
        })}
      >
        <p
          className={classNames('title', {
            'tw-pr-16': isSiglePic,
          })}
        >
          {title}
        </p>
        <div
          className={classNames('images-wrap', {
            'tw-hidden': isNonePic,
            'tw-w-111 tw-block md:tw-hidden lg:tw-hidden xl:tw-block': isSiglePic,
          })}
        >
          {!isNonePic && renderImageList()}
        </div>
      </div>
      <p
        className={classNames('user-wrap', {
          'sm:tw-pr-0 md:tw-pr-0 xl:tw-pr-111': isSiglePic,
        })}
      >
        <a
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          href={`/user/ugc_profile/${userId}`}
          className="user item-one-line-text"
          onClick={e => {
            e.stopPropagation()
            sendTeaCommEvent('clk_event', {
              event_id: 'feed_user_profile',
              author_id: `${userId}`,
              group_id: uniqueIdStr,
            })
          }}
        >
          {name}
        </a>
        <span className="commet">{commentCount}评论</span>
        <span className="type">{isVideo ? '视频' : '文章'}</span>
      </p>
      <style jsx>
        {`
          .nav-feed-item {
            position: relative;
            padding: 15px 19px 14px 24px;
            cursor: pointer;
          }
          .images-wrap {
            position: relative;
            height: 62px;
            margin-bottom: 4px;
            margin-top: 4px;
            overflow: hidden;
          }

          .title {
            font-size: 16px;
            padding-bottom: 4px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            line-height: 1.4;
            flex: 1;
            max-height: 46px;
          }

          .user-wrap {
            color: #979aa8;
            font-size: 14px;
            display: flex;
          }
          .user {
            display: inline-block;
            max-width: calc(100% - 111px);
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
          }
          .user:hover {
            color: #1f2129;
          }
          .commet {
            display: inline-block;
            padding: 0 2px 0 8px;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            overflow: hidden;
          }
          .type {
            display: inline-block;
            padding: 0 4px;
            border-radius: 2px;
            border: solid 1px #c9cbd6;
            transform: scale(0.71);
            width: 44px;
            text-align: center;
          }
        `}
      </style>
    </div>
  )
}

export default Item
